/*
    this script handles 2 things:
        1) automatically resizing textareas to fit their content
           when a user enters text in them, and
        2) more robustly toggling textareas when a user clicks
           a toggle element or activates a checkbox/radio button.
    at some point it might be a good idea to move the second
    behaviour over into the toggle.js plugin, which i avoided
    this time because it doesn't handle extra cases like radio
    buttons and instead just relies on the 'click' event handler.

    to make a textarea auto-resizable, just add the '.js-autoresize'

    to enable textarea toggling, first the textarea needs its own
    id. then some other element should have:
        1) the class '.js-autoresize-toggle', and
        2) a data-attribute 'js-autoresize-toggle-target' whose
           is the id of the textarea (in the input-group partial,
           there is a way to add data-attributes and extra classes
           to input elements).
    also, if the textarea isn't shown when the page loads, the
    '.js-autosize-reloaded' class should be added so it doesn't
    cause weird shifts in content when the js runs.
*/

function resize(element, from) {
    if(!element.classList.contains('js-autoresize-open')) return;

    /*
        this is a bit hacky because we want to animate the textarea
        expanding and shrinking with a CSS transition. however, CSS
        transition won't work with `height:auto` BUT we need to use
        `height:auto` to get the desired height to expand to. so we
        have to set it to auto first, grab the desired height, THEN
        set the height to the old height again in order to smoothly
        transition to the new height when we set that later. we can
        ask the browser to update the height only after the current
        execution queue by using a 0ms setTimeout() call.
    */
    element.style.height = 'auto';
    let newHeight = element.scrollHeight;
    element.style.height = from + 'px';
    setTimeout(() => {
        element.style.height = newHeight + 'px';
    }, 0);
}

// if `force` argument is supplied, set the class state to whatever that is
// otherwise just toggle the state
function toggle(textarea, force) {
    if(force != undefined) {
        if(force == false && textarea.classList.contains('js-autoresize-open')) {
            textarea.classList.remove('js-autoresize-open');
        } else if(force == true && !textarea.classList.contains('js-autoresize-open')) {
            textarea.classList.add('js-autoresize-open');
        }
    } else {
        textarea.classList.toggle('js-autoresize-open');
    }

    if(textarea.classList.contains('js-autoresize-open')) {
        resize(textarea);
    } else {
        // gotta do this so the inline styles don't override the
        // styles in scss files.
        textarea.style.height = '';
    }
}

function initToggle(textarea) {
    if(!textarea.id) {
        // textarea has no id, meaning no toggle control can target it
        // we're done here
        return;
    }

    let control = document.querySelector(`.js-autoresize-toggle[data-js-autoresize-toggle-target="${textarea.id}"]`);

    if(!control) {
        // no toggle found, we're done here
        return;
    }

    if (control.tagName.toLowerCase() === 'input') {
        let inputType = control.getAttribute('type');

        // only want to deal with checkbox or radio buttons at the moment
        if(inputType == 'checkbox') {
            // force the toggle state to state of input
            control.addEventListener('change', event => toggle(textarea, event.target.checked));
        } else if(inputType == 'radio') {
            initRadioGroupToggleListeners(textarea, control);
        }
    } else {
        // otherwise we just grab click events on other elements like div, a etc
        // and toggle the class from whatever it was before
        control.addEventListener('change', () => toggle(textarea))
    }
}

function initRadioGroupToggleListeners(textarea, control) {
    // uh oh. control is a radio and there's no `deselect` event for
    // inputs. we have the get the whole group of inputs and check if
    // it's NOT our control

    let group = document.querySelectorAll(`input[type="radio"][name="${control.getAttribute('name')}"]`)
    for(let radio of group) {
        radio.addEventListener('change', () => toggle(textarea, radio.id == control.id));
    }
}

function initResize(textarea) {
    for (let event of ['change', 'cut', 'paste', 'drop', 'keydown']) {
        textarea.addEventListener(event, function () {
            if(textarea.classList.contains('js-autoresize-open')) {
                let from = textarea.scrollHeight;
                setTimeout(() => resize(textarea, from), 0);
            }
        });
        setTimeout(() => {
            // first initialisation
            textarea.classList.remove('js-autoresize-unloaded');
            resize(textarea, 0)
        }, 0);
    }
}

module.exports.init = () => {
    for (let textarea of document.querySelectorAll('textarea.js-autoresize')) {
        initResize(textarea);
        initToggle(textarea);
    }
}



// WEBPACK FOOTER //
// ./modules/textareaResize.js